export const MAX_ACCOUNTS = 5
